<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.noBorder]: noBorder
      }
    ]"
  >
    <div
      v-if="$slots.footerSub"
      :class="$style.footerSection"
    >
      <slot name="footerSub" />
    </div>
    <div
      v-if="$slots.footer"
      :class="$style.footerSection"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  noBorder?: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  padding: $spacing * 1.5;
  border-top: 1px solid var(--border);
  align-items: center;
  background-color: var(--surface-primary);
  border-bottom-left-radius: $modal-radius;
  border-bottom-right-radius: $modal-radius;

  &:not(.smallScreen) {
    display: flex;
    justify-content: space-between;

    & > *:not(:last-child) {
      margin-right: $spacing;
    }
  }

  &.smallScreen {
    & > *:not(:last-child) {
      margin-bottom: $spacing;
    }
  }

  &.noBorder {
    border-top: none;
  }
}

.footerSection {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: $spacing;

  .base.smallScreen & {
    flex-direction: column;
    align-items: stretch;

    & > * {
      &:not(:last-child) {
        margin-right: 0;
      }
    }
  }

  &:empty {
    .base.smallScreen & {
      display: none;
    }
  }
}

.footerSection:empty + .footerSection {
  width: 100%;
}
</style>
